import { bsAlert } from '@shared/components/bsAlerts';

export const copyToClipboard = (value: string) => {
    let input = document.createElement('input');
    input.setAttribute('value', value);
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(input.value);
    document.body.removeChild(input);

    bsAlert({ title: $Resources.copyToClipboardAlertHeading, content: $Resources.copyToClipboardAlertText });
};
